<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('conflictos.conflictos.conflictos')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <!-- rList Table CARD-->
      <r-list
        ref="rlist"
        slot="default"
        :dbAdapter="Conflicto"
        sort="fechaConflicto"
        sortDir="DESC"
        :tableMode="true"
        :virtualListParams="{height:32}"
        class="card full-height data-table"
        classContent="card-content full-height"
      >
        <template v-slot:before="{rlist}">
          <f7-card-header>
            <div class="data-table-header" v-if="Object.keys(rlist.selected).length==0">
              <div class="data-table-actions">
                <f7-link small @click="rlist.refresh()" icon-f7="arrow_counterclockwise"></f7-link>
                <f7-link small @click="rlist.exportExcel('Incidencias.xlsx')" icon-f7="doc_text_fill"  v-tooltip="'Exportar a Excel'"></f7-link>
                <f7-link
                  small
                  @click="$refs.rpanel.toggle()"
                  icon-f7="line_horizontal_3_decrease"
                  v-show="!rPanelOpenedByBreakpoint"
                ></f7-link>
              </div>
            </div>
            <div class="data-table-header-selected display-flex" v-else>
              <!-- Selected table title -->
              <div class="data-table-title-selected">
                <span
                  class="data-table-selected-count"
                >{{$tc('rlist.n_registros_seleccionados', Object.keys(rlist.selected).length, {count:Object.keys(rlist.selected).length}) }}</span>
              </div>
              <!-- Selected table actions -->
              <div class="data-table-actions">
                <f7-link icon-f7="trash"></f7-link>
              </div>
            </div>
          </f7-card-header>
        </template>

        <template v-slot:header="{rlist}">
          <thead class="thead-sticky">
            <tr>
              <th class="checkbox-cell" style="width: 2rem;">
                <label class="checkbox">
                  <input type="checkbox" @change="rlist.toggleSelectAll($event.target.checked)" />
                  <i class="icon-checkbox"></i>
                </label>
              </th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('tipoConflicto')"
                :class="rlist.sortableClasses('tipoConflicto')"
              >{{$t('conflictos.conflicto_form.tipo_conflicto')}}</th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('resolucion')"
                :class="rlist.sortableClasses('resolucion')"
              >{{$t('conflictos.conflicto_form.resolucion')}}</th>
              <th>{{$t('conflictos.conflicto_form.estandar')}}</th>
              <th>{{$t('conflictos.conflicto_form.subestandar')}}</th>
              <th>{{$t('conflictos.conflicto_form.matricula')}}</th>
              <th>{{$t('conflictos.conflicto_form.bastidor')}}</th>
              <th>{{$t('conflictos.conflicto_form.modelo')}}</th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('fechaConflicto')"
                :class="rlist.sortableClasses('fechaConflicto')"
              >{{$t('conflictos.conflicto_form.fecha_conflicto')}}</th>
              <th
                style="min-width:1em;"
                @click="rlist.setOrder('fechaResolucion')"
                :class="rlist.sortableClasses('fechaResolucion')"
              >{{$t('conflictos.conflicto_form.fecha_resolucion')}}</th>
              <th>{{$t('conflictos.conflicto_form.cliente')}}</th>
              <th style="width:7em;" class="label-cell text-align-center right-column-sticky">
                <f7-icon f7="gear_alt_fill"></f7-icon>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:default="{vlData,rlist}">
          <tr v-for="(item) in vlData.items" :key="'inspeccion-'+item.id">
            <th class="checkbox-cell">
              <label class="checkbox">
                <input
                  type="checkbox"
                  :checked="item.id in rlist.selected"
                  @change="rlist.toggleSelect(item, $event.target.checked)"
                />
                <i class="icon-checkbox"></i>
              </label>
            </th>
            <td v-html="getTipoConflictoBadge(item.tipoConflicto)"></td>
            <td v-html="getResolucionConflictoBadge(item.resolucion)"></td>
            <td>{{item.estandar}}</td>
            <td>{{item.subEstandar}}</td>
            <td>{{!item.inspeccion.coche ? '' : item.inspeccion.coche.matricula}}</td>
            <td>{{!item.inspeccion.coche ? '' : item.inspeccion.coche.bastidor}}</td>
            <td>{{!item.inspeccion.coche ? '' : item.inspeccion.coche.modelo.marca.nombre}} {{!item.inspeccion.coche ? '' : item.inspeccion.coche.modelo.nombre}}</td>
            <td>{{item.fechaConflicto || '-' | dateParse | dateFormat('DD/MM/YYYY')}}</td>
            <td>{{item.fechaResolucion || '-' | dateParse | dateFormat('DD/MM/YYYY')}}</td>
            <td class>{{item.cliente ? item.cliente.nombre : ''}}</td>
            <td class="text-align-right right-column-sticky">
              <f7-link icon-f7="eye" color="green" :href="`/conflictos/view/${item.id}/`" v-tooltip="'Ver Incidencia'"></f7-link>
            </td>
          </tr>
        </template>
        <template v-slot:afterInner="{rlist}">
          <rPanel
            ref="rpanel"
            side="right"
            @openedByBreakpoint="rPanelOpenedByBreakpoint=true"
            @closedByBreakpoint="rPanelOpenedByBreakpoint=false"
            v-slot="{rpanel}"
          >
            <r-form @submit="rlist.setFilter($event); rpanel.close();">
              <template v-slot:before="{rform}">
                <f7-toolbar>
                  <div>Filtro</div>
                  <f7-link icon-f7="bin_xmark" @click="rform.clear();"></f7-link>
                </f7-toolbar>
              </template>
              <template v-slot="{rform}">
                <f7-list no-hairlines-md>
                  <template v-slot:list>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('conflictos.conflicto_form.matricula')"
                      :form="rform"
                      type="text"
                      name="matricula"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('conflictos.conflicto_form.bastidor')"
                      :form="rform"
                      type="text"
                      name="bastidor"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('conflictos.conflicto_form.estandar')"
                      :form="rform"
                      type="text"
                      name="estandar"
                    ></r-input>
                    <r-input
                      maxlength="256"
                      floating-label
                      :label="$t('conflictos.conflicto_form.subestandar')"
                      :form="rform"
                      type="text"
                      name="subEstandar"
                    ></r-input>
                    <r-input
                      floating-label
                      :label="$t('conflictos.conflicto_form.tipo_conflicto')"
                      :form="rform"
                      type="select"
                      name="tipoConflicto"
                    >
                      <option selected></option>
                      <option value="RESUELTO_CAMPO">Resuelto en Campo</option>
                      <option value="ENVIADO_MARCA">Enviado a Marca</option>
                    </r-input>
                    <r-input
                      floating-label
                      :label="$t('conflictos.conflicto_form.resolucion')"
                      :form="rform"
                      type="select"
                      name="resolucion"
                    >
                      <option selected></option>
                      <option value="OK">Positiva</option>
                      <option value="KO">Negativa</option>
                    </r-input>
                    <r-autocomplete
                      :dbAdapter="Cliente"
                      floating-label
                      :label="$t('inspecciones.inspeccion_form.cliente')"
                      :form="rform"
                      name="idCliente"
                      idProp="id"
                      labelProp="nombre"
                      ref="cliente"
                      @loaded="if($event.length==1) $refs.cliente.setValue($event[0]);"
                    ></r-autocomplete>

                    <li class="label-group"><label>{{$t('conflictos.conflicto_form.fecha_conflicto')}}</label></li>
                    <r-input
                      floating-label
                      :label="$t('conflictos.conflicto_form.desde')"
                      :form="rform"
                      type="datepicker"
                      name="fechaConflictoDesde"
                      :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                    ></r-input>
                    <r-input
                      floating-label
                      :label="$t('conflictos.conflicto_form.hasta')"
                      :form="rform"
                      type="datepicker"
                      name="fechaConflictoHasta"
                      :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                    ></r-input>

                    <li class="label-group"><label>{{$t('conflictos.conflicto_form.fecha_resolucion')}}</label></li>
                    <r-input
                      floating-label
                      :label="$t('conflictos.conflicto_form.desde')"
                      :form="rform"
                      type="datepicker"
                      name="fechaResolucionDesde"
                      :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                    ></r-input>
                    <r-input
                      floating-label
                      :label="$t('conflictos.conflicto_form.hasta')"
                      :form="rform"
                      type="datepicker"
                      name="fechaResolucionHasta"
                      :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                    ></r-input>

                    <f7-button type="submit" class="margin-vertical" icon-f7="search">Buscar</f7-button>
                  </template>
                </f7-list>
              </template>
            </r-form>
          </rPanel>
        </template>
        <template v-slot:after="{rlist}">
          <f7-card-footer>
            <span>
              <b>{{$tc('rlist.n_registros', rlist.count, {count:rlist.count})}}</b>
            </span>
          </f7-card-footer>
        </template>
      </r-list>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
<script>
import rList from "./../../components/rList.vue";
import rPanel from "./../../components/rPanel.vue";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import Inspeccion from "./../../js/db/Inspeccion.js";
import Conflicto from "./../../js/db/Conflicto.js";
import Cliente from "./../../js/db/Cliente.js";
export default {
  components: {
    rList,
    rPanel,
    rForm,
    rInput,
    rAutocomplete
  },
  data() {
    return {
      Inspeccion,
      Conflicto,
      Cliente,
      rPanelOpenedByBreakpoint: false
    };
  },
  computed: {},
  methods: {
    getTipoConflictoBadge: function(tipoConflicto) {
      switch (tipoConflicto) {
        case "RESUELTO_CAMPO":
          var texto = "Resuelto en campo";
          var color = "green";
          break;
        case "ENVIADO_MARCA":
          var texto = "Enviado marca";
          var color = "orange";
          break;
        default:
          var texto = tipoConflicto;
          var color = "gray";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getResolucionConflictoBadge: function(resolucion) {
      switch (resolucion) {
        case "OK":
          var texto = "Positiva";
          var color = "green";
          break;
        case "KO":
          var texto = "Negativa";
          var color = "red";
          break;
        default:
          var texto = "Sin resolver";
          var color = "gray";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    }
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    /*app.dataTable.create({
      el: self.$refs.datatable
    });*/
  }
};
</script>